import { useTranslation } from 'react-i18next';

import { CustomSelect } from 'libs/ui';

const modes = [
  { value: 'regular', name: 'Штатный' },
  { value: 'emergency', name: 'Блокированный' },
  { value: 'test', name: 'Сервисный' },
  { value: 'free', name: 'Свободный' },
];

export const ModeInput = (props) => {
  const { t } = useTranslation();
  const { onChange, name, value } = props;
  const items = modes.map((m) => ({ ...m, name: t('clarifications.' + m.name) }));
  return <CustomSelect items={items} value={value} onChange={(v) => onChange(name, v)} style={{ width: '170px' }} className="size-sm" />;
};
